<template v-loading="IsLoading" element-loading-text="加载中">
  <detail-page-layout :config="pageConfig">
    <!--<h3 class="title-h3">
      <span class="title-h3-icon"><i class="el-icon-circle-check"></i></span>
      <span class="title-h3-text">充值完成！</span>
      <p>如遇到问题，请 <a href="http://wpa.qq.com/msgrd?v=3&uin=2850559846&site=qq&menu=yes">联系我们</a>！</p>
    </h3>-->
    <div class="title-h3-text2">当前余额：<span>{{Balance | amount}}</span> 元</div>
  <el-row class="title-border">
      <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="CreateOn"
        label="充值时间">
        <template scope="scope">
          <span>{{scope.row.CreateOn | date('YYYY-MM-DD HH:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Code"
        label="流水号">
      </el-table-column>
      <el-table-column
        prop="Type"
        label="类型">
      </el-table-column>
      <el-table-column
        prop="Amount"
        label="充值金额">
        <template scope="scope">
          <span class="status" v-if= "scope.row.Amount > 0">{{scope.row.Amount | amount}}</span>
          <span class="green" v-if= "scope.row.Amount < 0">{{scope.row.Amount | amount}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Remark"
        label="说明">
      </el-table-column>
    </el-table>
  </el-row>
  </detail-page-layout>
</template>

<script>
import DetailPageLayout from '@/components/common/DetailPageLayout'
export default {
  created() {
    this.getData()
  },
  data() {
    return {
      tableData: [],
      Balance: null,
      pageConfig: {
        StepsBarEnabled: false,
        Breadcrumbs: [
          {
            to: {name: 'Deposit_statement'},
            name: '保证金支出报表',
          },
          {
            name: '充值详情',
          },
        ],
      },
      IsLoading: false,
    }
  },
  methods: {
     /* 获取订单详情 */
    getData() {
      this.IsLoading = true
      const id = this.$route.params.id
      this.$http.get(process.env.API_HOST + '/finance/RentalOrder/Deposit?detailid=' + id).then(({data}) => {
        this.Balance = data.Balance
        this.tableData.push(data)
        this.IsLoading = false
      }).catch((response) => {
        this.IsLoading = false
      })
    },
  },
  components: {
    DetailPageLayout,
  },
}
</script>
<style scoped>
.title-border{
  border-top: 1px solid #ccc;
  padding: 20px 0;
  font-size: 16px;
  line-height: 30px;
}
.status{
  color: red;
}
.green{
  color: green;
}
.title-border th{background: #fff;}
.title-h3-text2{text-align: center;clear: both;padding: 20px 0;}
.title-h3-text2 span{color: #1AB974;font-size: 30px;}
.title-h3{padding-left: 4.16667%;}
.title-h3-icon{font-size: 80px;float: left;color: #F07959;padding: 20px 20px 20px 0;}
.title-h3-text{font-size: 24px;padding-top: 38px;}
.title-h3 a{color: #20a0ff;}
.title-border{clear: both;}
</style>



// WEBPACK FOOTER //
// DepositDetail.vue?e6f053b4